import { render, staticRenderFns } from "./TaxRateCard.vue?vue&type=template&id=4383cdba&scoped=true&"
import script from "./TaxRateCard.vue?vue&type=script&lang=js&"
export * from "./TaxRateCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=4383cdba&prod&lang=less&scoped=true&"
import style1 from "./TaxRateCard.vue?vue&type=style&index=1&id=4383cdba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4383cdba",
  null
  
)

export default component.exports